import { createFileRoute } from '@tanstack/react-router';
import { isPermissionParcialOrFull } from '@/features/login/util/permission';
import { validateRoute } from '@/router/util';

export const Route = createFileRoute('/a/relatorio/fiscal')({
    beforeLoad: () => {
        validateRoute({
            fintech: false,
            validatePermission: ({ upp_relatorio_fiscal }) =>
                isPermissionParcialOrFull(upp_relatorio_fiscal),
        });
    },
});
